import React from 'react';
import {connect} from "react-redux";

import AppLayout from "../components/AppLayout";
import InvokeDisbursementPanel from "../components/InvokeDisbursementPanel";
import { submitIpcRequest } from "../store/actions/consoleActions";

function PaymentsPage(props) {
    return (
        <AppLayout title="Payments">
            <InvokeDisbursementPanel submitRequest={props.submitIpcRequest}/>
        </AppLayout>
    )
}

export default connect(null, {submitIpcRequest})(
    PaymentsPage
);
